import * as React from 'react'
import Cropper from "react-cropper"
import "cropperjs/dist/cropper.css"
import { I18n } from 'react-redux-i18n'

import ModalWrapper from '../ChannelView/ModalWrapper'

import './styles.scss'
import Nixi1Spinner from 'components/Nixi1Spinner'

const ImageCropper = (props) => {
  const cropperRef = React.useRef(null)
  const [loading, setLoading] = React.useState(true)
  const [uploading, setUploading] = React.useState(false)
  const [open, setOpen] = React.useState(false)
  const [croppedImage, setCroppedImage] = React.useState('')
  const onCrop = () => {
    const imageElement = cropperRef?.current
    const cropper = imageElement?.cropper
    setCroppedImage(cropper.getCroppedCanvas().toDataURL('image/jpeg'))
  }

  const toggle = () => {
    setOpen(!open)
    setLoading(true)
    setUploading(false)
  }

  const uploadFile = () => {
    setUploading(true)
    let arr = croppedImage.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), 
      n = bstr.length, 
      u8arr = new Uint8Array(n)
        
    while(n--){
      u8arr[n] = bstr.charCodeAt(n)
    }
    
    props.uploadFile([{ file: new File([u8arr], `croppedImage.${mime.split('/')[1]}`, { type:mime }) }]).then((data) => {
      toggle()
    }).catch(err => {
      console.error(err)
    })
  }

  const body = (
    <div className='cropper-container'>
      { loading &&
        <div className='loading-overlay'>
          <Nixi1Spinner width='25px' height='25px' />
          {/* <Loading /> */}
        </div>
      }
      <Cropper
        src={props.imageUrl}
        style={{ height: 400, width: "100%" }}
        // Cropper.js options
        initialAspectRatio={1}
        ready={() => setLoading(false)}
        guides={true}
        crop={onCrop}
        ref={cropperRef}
      />
      <div className='buttons-container'>
        <div className='shiftLabel'>SHIFT = {I18n.t('dashboard_set-aspect-ratio')}</div>
        <div className='btn btn-primary' onClick={uploadFile} style={{ minWidth: '85px' }}>
          { uploading ?
            <Nixi1Spinner width='1rem' height='1rem' /> :
            I18n.t('dashboard_save')
          }
        </div>
        <div className='shiftLabel'></div>
      </div>
    </div>
  )

  return (
    <>
      <div className='btn btn-primary' onClick={toggle}>{I18n.t('dashboard_edit')}</div>
      <ModalWrapper
        id={'modalWebWidget'}
        header={' '}
        body={body}
        isOpen={open}
        toggle={toggle}
        showClose={true}
      />
    </>
  )
}

export default ImageCropper